import React from 'react';
import { FavoriteBorder, TrackChanges, Visibility } from "@mui/icons-material"
import { Stack } from "@mui/material"
import Box from "@mui/material/Box"
import Card from "@mui/material/Card"
import Typography from "@mui/material/Typography"
import Container from "@mui/system/Container"

const AboutUs: React.FC = () => {
    return(
        <Container
            maxWidth="xl"
            sx={{
                pt: { xs: 4, sm: 6, md: 8, lg: 10 },
                pb: { xs: 3, sm: 4, md: 5, lg: 6 },
                px: { xs: 2, sm: 3, md: 4 }
            }}
        >
            <Box sx={{
                textAlign: 'center',
                mb: { xs: 4, sm: 5, md: 6, lg: 8 },
                px: { xs: 1, sm: 2 }
            }}>
                <Typography
                    variant="h2"
                    fontWeight={700}
                    gutterBottom
                    sx={{
                        color: 'primary.dark',
                        fontSize: { xs: '1.5rem', sm: '1.875rem', md: '2rem', lg: '2.25rem', xl: '2.5rem' },
                        mb: { xs: 2, md: 3 }
                    }}
                >
                    Nuestra Institución
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                        maxWidth: { xs: '100%', sm: 600, md: 700, lg: 800, xl: 900 },
                        mx: 'auto',
                        fontSize: { xs: '0.875rem', sm: '0.938rem', md: '1rem', lg: '1.063rem' },
                        lineHeight: { xs: 1.6, md: 1.7 },
                        px: { xs: 1, sm: 0 }
                    }}
                >
                    La Institución Educativa José Eusebio Caro es un establecimiento público que ofrece educación de calidad en 5 sedes distribuidas
                    en Popayán. Atendemos a estudiantes desde el nivel preescolar hasta la educación media, brindando una formación académica y
                    sólida con énfasis en valores, tecnología y desarrollo social.
                </Typography>
            </Box>

            {/* Mission, Vision, Values Cards */}
            <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={{ xs: 3, sm: 3.5, md: 4, lg: 5 }}
                sx={{
                    mb: { xs: 3, sm: 4, md: 5 },
                    mx: { xs: 0, sm: 2, md: 4, lg: 8, xl: 20 }
                }}
            >
                {/* Nuestra Misión */}
                <Card
                    elevation={0}
                    sx={{
                        flex: 1,
                        border: '1px solid #E0E0E0',
                        borderRadius: { xs: 2, md: 3 },
                        textAlign: 'center',
                        p: { xs: 2.5, sm: 3, md: 3.5, lg: 4 },
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        '&:hover': {
                            transform: { md: 'translateY(-8px)' },
                            boxShadow: { md: '0 8px 24px rgba(0,0,0,0.12)' }
                        }
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: { xs: 1.5, md: 2 } }}>
                        <TrackChanges sx={{
                            fontSize: { xs: 48, sm: 56, md: 60, lg: 70 },
                            color: 'primary.dark'
                        }} />
                    </Box>
                    <Typography
                        variant="h5"
                        fontWeight={700}
                        gutterBottom
                        sx={{
                            color: 'primary.dark',
                            fontSize: { xs: '1.125rem', sm: '1.188rem', md: '1.25rem', lg: '1.375rem' },
                            mb: { xs: 1.5, md: 2 }
                        }}
                    >
                        Nuestra Misión
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            fontSize: { xs: '0.813rem', sm: '0.875rem', md: '0.938rem', lg: '1rem' },
                            lineHeight: { xs: 1.6, md: 1.7 },
                            textAlign: 'justify'
                        }}
                    >
                        La Institución Educativa JOSÉ EUSEBIO CARO de Popayán tiene como propósito formar estudiantes en los saberes fundamentales de las ciencias, autónomos, íntegros, sensibles, emprendedores, con sentido humano y proyección social; que apoyada en procesos pedagógicos fortalezca su formación académica y su orientación laboral futura, acorde con las nuevas tendencias tecnológicas, con el desarrollo social, ambiental y cultural de su entorno y con las necesidades propias de la comunidad donde se desenvuelven.
                    </Typography>
                </Card>

                {/* Nuestra Visión */}
                <Card
                    elevation={0}
                    sx={{
                        flex: 1,
                        border: '1px solid #E0E0E0',
                        borderRadius: { xs: 2, md: 3 },
                        textAlign: 'center',
                        p: { xs: 2.5, sm: 3, md: 3.5, lg: 4 },
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        '&:hover': {
                            transform: { md: 'translateY(-8px)' },
                            boxShadow: { md: '0 8px 24px rgba(0,0,0,0.12)' }
                        }
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: { xs: 1.5, md: 2 } }}>
                        <Visibility sx={{
                            fontSize: { xs: 48, sm: 56, md: 60, lg: 70 },
                            color: 'primary.dark'
                        }} />
                    </Box>
                    <Typography
                        variant="h5"
                        fontWeight={700}
                        gutterBottom
                        sx={{
                            color: 'primary.dark',
                            fontSize: { xs: '1.125rem', sm: '1.188rem', md: '1.25rem', lg: '1.375rem' },
                            mb: { xs: 1.5, md: 2 }
                        }}
                    >
                        Nuestra Visión
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            fontSize: { xs: '0.813rem', sm: '0.875rem', md: '0.938rem', lg: '1rem' },
                            lineHeight: { xs: 1.6, md: 1.7 },
                            textAlign: 'justify'
                        }}
                    >
                        La Institución Educativa JOSÉ EUSEBIO CARO de Popayán será reconocida a nivel local y regional por sus avances y liderazgo en su oferta de una educación integral e incluyente haciendo uso óptimo de las TIC y la formación en valores.
                    </Typography>
                </Card>

                {/* Nuestros Valores */}
                <Card
                    elevation={0}
                    sx={{
                        flex: 1,
                        border: '1px solid #E0E0E0',
                        borderRadius: { xs: 2, md: 3 },
                        textAlign: 'center',
                        p: { xs: 2.5, sm: 3, md: 3.5, lg: 4 },
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        '&:hover': {
                            transform: { md: 'translateY(-8px)' },
                            boxShadow: { md: '0 8px 24px rgba(0,0,0,0.12)' }
                        }
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: { xs: 1.5, md: 2 } }}>
                        <FavoriteBorder sx={{
                            fontSize: { xs: 48, sm: 56, md: 60, lg: 70 },
                            color: 'primary.dark'
                        }} />
                    </Box>
                    <Typography
                        variant="h5"
                        fontWeight={700}
                        gutterBottom
                        sx={{
                            color: 'primary.dark',
                            fontSize: { xs: '1.125rem', sm: '1.188rem', md: '1.25rem', lg: '1.375rem' },
                            mb: { xs: 1.5, md: 2 }
                        }}
                    >
                        Nuestros Valores
                    </Typography>
                    <Box component="ul" sx={{
                        textAlign: 'left',
                        pl: { xs: 2, sm: 3, md: 4 },
                        m: 0
                    }}>
                        {['Respeto', 'Responsabilidad', 'Honestidad', 'Solidaridad', 'Tolerancia', 'Autoestima', 'Sentido de Pertenencia', 'Amistad'].map((valor) => (
                            <Typography
                                key={valor}
                                component="li"
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                    fontSize: { xs: '0.813rem', sm: '0.875rem', md: '0.938rem', lg: '1rem' },
                                    lineHeight: { xs: 1.6, md: 1.7 },
                                    mb: 0.5
                                }}
                            >
                                {valor}
                            </Typography>
                        ))}
                    </Box>
                </Card>
            </Stack>
        </Container>)
}

export default AboutUs